/**
 * Mixin responsible for provide easy methods to funnel calculations
 *
 * @author Jefferson García Aristizábal
 */
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ModalMixin extends Vue {
  show() {
    this.$refs.modal.show()
  }

  hide() {
    this.$refs.modal.hide()
  }
}
